export default __webpack_public_path__ + "static/media/design-analytics.2b01ef29.png";